import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Toggle } from '../../../../../../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle';
import {
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from '@material-ui/core';
import moment from 'moment';
import Switch from 'react-switch';
import { NewInputText } from '../../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent';
import TimeInput from 'material-ui-time-picker';
import { AddButtonIconComponent } from '../../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent';
import { InputCharacterCheck } from '../../../../../../../../function/InputCharNumCheckFunc';
const foodTime = ['breakfast', 'lunch', 'dinner'];

const dayArray = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

function Availability({ formik, data, comboDetails, props }) {
  const [minEndDate, setMinEndDate] = useState(
    moment(formik.values.date_of_availability.start_date).format('YYYY-MM-DD')
  );

  const [minDate, setMinDate] = useState(
    moment(formik.values.date_of_availability.start_date).format(
      'YYYY-MM-DD'
    ) || moment().format('YYYY-MM-DD')
  );

  const handleStartDateChange = (e) => {
    formik.setFieldValue('date_of_availability.start_date', e.target.value);
    formik.setFieldValue('date_of_availability.end_date', '');
    setMinEndDate(e.target.value);
  };

  const [state, setState] = useState({
    monday: comboDetails?.weeklyAvailability?.monday || {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: 'Dinner',
        },
      ],
    },
    tuesday: comboDetails?.weeklyAvailability?.tuesday || {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: 'Dinner',
        },
      ],
    },
    wednesday: comboDetails?.weeklyAvailability?.wednesday || {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: 'Dinner',
        },
      ],
    },
    thursday: comboDetails?.weeklyAvailability?.thursday || {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: 'Dinner',
        },
      ],
    },
    friday: comboDetails?.weeklyAvailability?.friday || {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: 'Dinner',
        },
      ],
    },
    saturday: comboDetails?.weeklyAvailability?.saturday || {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: 'Dinner',
        },
      ],
    },
    sunday: comboDetails?.weeklyAvailability?.sunday || {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: 'Dinner',
        },
      ],
    },
  });

  useEffect(() => {
    // Only update formik value if state.weeklyAvailability is different
    if (formik.values.weeklyAvailability !== state) {
      formik.setFieldValue('weeklyAvailability', state);
    }
  }, [state, formik.values.weeklyAvailability]);

  const onDayOpenCloseHanlder = (day, foodTime, multiple) => (e) => {
    let dayData = state[day];
    dayData.open = !dayData.open;
    setState({ ...state });
    if (dayData.open === false && multiple === 'single') {
      dayData.breakfast.open = false;
      dayData.lunch.open = false;
      dayData.dinner.open = false;
    } else {
      setState({ ...state });
    }
    if (
      state['monday'].open === false &&
      state['tuesday'].open === false &&
      state['wednesday'].open === false &&
      state['thursday'].open === false &&
      state['friday'].open === false &&
      state['saturday'].open === false &&
      state['sunday'].open === false &&
      multiple === 'multiple'
    ) {
      setState({
        ...state,
      });
    } else {
      setState({
        ...state,
      });
    }
  };

  const onMultipleAddHandler = (day) => (e) => {
    e.preventDefault();
    // let state = state;
    let dayData = state[day];
    let phone = dayData.multiple_timings;
    let dayDataDesc =
      phone[phone?.length - 1] && phone[phone?.length - 1]?.description;
    if (dayDataDesc === '') {
      const { errors } = state;
      errors.description = 'Description Is Required';
      setState({
        ...state,
        errors: errors,
      });
    } else {
      let newMultiple = {
        open: true,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 23),
        description: '',
      };
      phone.push(newMultiple);
      setState({
        ...state,
        checkPoint: true,
      });
    }
  };

  const onMultileDeleteHandler = (day, index) => (e) => {
    e.preventDefault();
    // let state = state;
    let dayData = state[day];
    let phone = dayData.multiple_timings;
    if (phone?.length === 1) {
      window.alert('Cannot Delete elements');
    } else {
      phone.splice(index, 1);
      setState({ ...state, errors: [] });
    }
    props.clear_all_errors();
  };

  const handleChangeOpeningCloseing = (time, day, inputType, index) => {
    if (inputType === 'opening_time') {
      // let state = state;
      let dayData = state[day];
      let multipleOpening = dayData.multiple_timings;
      multipleOpening[index].opening_time = new Date(time);
      setState({ ...state });
    } else if (inputType === 'closing_time') {
      // let state = state;
      let dayData = state[day];
      let multipleClosing = dayData.multiple_timings;
      multipleClosing[index].closing_time = new Date(time);
      setState({ ...state });
    }
  };

  const handleChangeInputTextArray = (day, index) => (e) => {
    // let state = state;
    let dayData = state[day];
    let multipleText = dayData.multiple_timings;
    let data = e.target.value.split(' ');
    let newarray1 = [];
    for (let x = 0; x < data?.length; x++) {
      newarray1.push(data[x].charAt(0).toUpperCase() + data[x].slice(1));
    }
    let newData = newarray1.join(' ');
    multipleText[index][e.target.name] = newData;

    setState({
      ...state,
      checkPoint: false,
    });
  };

  const handleChangeMultipleHoursToggle = (day, hours, index) => (e) => {
    // let state = state;
    let dayData = state[day];
    let multipleToggle = dayData.multiple_timings;
    multipleToggle[index].open = !multipleToggle[index].open;
    setState({
      ...state,
      // state: state,-
    });
  };

  const onFocusOut = (e) => {
    const { errors } = state;
    if (e.target.value === '') {
      errors[e.target.name] = `Description Is Required`;
    } else {
      errors[e.target.name] = '';
    }
    setState({
      ...state,
      errors: errors,
    });
  };

  const copyMultipleTimeFunction = (day) => (e) => {
    e.preventDefault();
    // let state = state;
    let dayData = state[day];
    let days = [
      'monday',
      'tuesday',
      'wednesday',
      'thursday',
      'friday',
      'saturday',
      'sunday',
    ];
    let index = days.indexOf(day);
    days = days.slice(index + 1, days?.length);
    let daysData = {};
    days.forEach((day) => {
      daysData[day] = JSON.parse(JSON.stringify(dayData));
    });
    setState({
      ...state,
      ...daysData,
    });
  };

  const copyMultipleTimeFunctionError = (e) => {
    const { errors } = state;
    errors.description = 'Description Is Required';
    setState({
      ...state,
      errors: errors,
    });
  };

  console.log(formik.values);

  return (
    <>
      <Row>
        <Col md={8}>
          <div className="f18-500 my-2">Food or Package Availability</div>
          <div className=" d-flex ml-1">
            <div className="f14-500">combo Name :</div>
            <div className="f14-700">{data?.values?.comboName || ''}</div>
          </div>
          <div className="d-flex  my-2">
            <div className="my-2 d-flex justify-content-evenly">
              <div className="f16-500">Active Status</div>

              <Col>
                <div className="d-flex align-items-center">
                  <div className="f12-400 mr-2">No</div>
                  <Toggle
                    checked={formik.values.activeStatus}
                    toggleFunction={() =>
                      formik.setFieldValue(
                        'activeStatus',
                        !formik.values.activeStatus
                      )
                    }
                  />
                  <div className="f12-400 ml-2">Yes</div>
                </div>
              </Col>
            </div>
            <div className="borderRight"></div>
            <div className="my-2 d-flex justify-content-evenly">
              <div className="f16-500">Combo Availability</div>

              <Col>
                <div className="d-flex align-items-center">
                  <div className="f12-400 mr-2">No</div>
                  <Toggle
                    checked={formik.values.availability}
                    toggleFunction={() =>
                      formik.setFieldValue(
                        'availability',
                        !formik.values.availability
                      )
                    }
                  />
                  <div className="f12-400 ml-2">Yes</div>
                </div>
              </Col>
            </div>
          </div>
          <div className="py-3">
            <div className="f18-700 col-12 col-md-8 col-lg-6 my-4 pl-0">
              Date of Availability
            </div>
            <Row>
              <Col md={3} xl={3} xs={6} className="pb-3">
                <TextField
                  id="startDate"
                  label="Start Date"
                  variant="outlined"
                  InputProps={{
                    inputProps: {
                      min:
                        moment(
                          formik.values.date_of_availability.start_date
                        ).format('YYYY-MM-DD') || minDate,
                    },
                  }}
                  type="date"
                  className={`w-100 }`}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="date_of_availability.start_date"
                  onChange={(e) => handleStartDateChange(e)}
                  value={moment(
                    formik.values.date_of_availability.start_date
                  ).format('YYYY-MM-DD')}
                  onBlur={formik.handleBlur}
                  // isInvalid={
                  //   formik.errors.date_of_availability.start_date &&
                  //   formik.touched.date_of_availability.start_date
                  // }
                />
                {/* {formik.errors.date_of_availability.start_date &&
                formik.touched.date_of_availability.start_date ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.date_of_availability.start_date}
                  </div>
                ) : null} */}
              </Col>
              <Col md={3} xl={3} xs={6} className="pb-3">
                <TextField
                  id="endDate"
                  label="End Date"
                  variant="outlined"
                  type="date"
                  className={`w-100}`}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    inputProps: {
                      min:
                        moment(
                          formik.values.date_of_availability.end_date
                        ).format('YYYY-MM-DD') ||
                        minEndDate ||
                        moment(
                          formik?.values?.date_of_availability.start_date
                        ).format('YYYY-MM-DD'),
                    },
                  }}
                  name="date_of_availability.end_date"
                  onChange={formik.handleChange}
                  value={moment(
                    formik.values.date_of_availability.end_date
                  ).format('YYYY-MM-DD')}
                  onBlur={formik.handleBlur}
                  // isInvalid={
                  //   formik.errors.date_of_availability.end_date &&
                  //   formik.touched.date_of_availability.end_date
                  // }
                />
                {/* {formik.errors.date_of_availability.end_date &&
                formik.touched.date_of_availability.end_date ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.date_of_availability.end_date}
                  </div>
                ) : null} */}
              </Col>
            </Row>
          </div>
          <div className="onboarding_process_screen-left-mapinside px-0">
            <div className="f14-700 col-8 col-md-8 col-lg-8 p-0">
              Weekly Availability
            </div>
            <div className="business_and_hours_onboarding_main">
              <RenderMultipleHoursInsideFields
                state={state}
                errors={state.errors}
                onDayOpenCloseHanlder={onDayOpenCloseHanlder}
                addOnClick={onMultipleAddHandler}
                deleteOnClick={onMultileDeleteHandler}
                handleChangeOpeningCloseing={handleChangeOpeningCloseing}
                handleChangeInputTextArray={handleChangeInputTextArray}
                handleChangeMultipleHoursToggle={
                  handleChangeMultipleHoursToggle
                }
                onFocusOut={onFocusOut}
                copyMultipleTimeFunctionError={copyMultipleTimeFunctionError}
                copyMultipleTimeFunction={copyMultipleTimeFunction}
              />
            </div>
          </div>
          <div className="py-3">
            <div className="f18-700 col-12 col-md-8 col-lg-6 my-4 pl-0">
              Time of Availability
            </div>
            <Row>
              <Col md={3} xl={3} xs={6} className="pb-3">
                <div className="f14-500 ml-2 my-2">Start Time</div>
                <TextField
                  id="startTime"
                  label="Start Time"
                  variant="outlined"
                  type="time"
                  defaultValue={formik.values.time_of_availability.start_time}
                  className={`w-100`}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="time_of_availability.start_time"
                  onChange={formik.handleChange}
                  value={formik.values.time_of_availability.start_time}
                  onBlur={formik.handleBlur}
                  // isInvalid={
                  //   formik.errors.time_of_availability.start_time &&
                  //   formik.touched.time_of_availability.start_time
                  // }
                />
                {/* {formik.errors.time_of_availability.start_time &&
                formik.touched.time_of_availability.start_time ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.time_of_availability.start_time}
                  </div>
                ) : null} */}
              </Col>
              <Col md={3} xl={3} xs={6} className="pb-3">
                <div className="f14-500 ml-2 my-2">Close Time</div>
                <TextField
                  id="closeTime"
                  label="Close Time"
                  variant="outlined"
                  type="time"
                  className={`w-100 }`}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="time_of_availability.end_time"
                  onChange={formik.handleChange}
                  value={formik.values.time_of_availability.end_time}
                  onBlur={formik.handleBlur}
                  // isInvalid={
                  //   formik.errors.time_of_availability.end_time &&
                  //   formik.touched.time_of_availability.end_time
                  // }
                />
                {/* {formik.errors.time_of_availability.end_time &&
                formik.touched.time_of_availability.end_time ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.time_of_availability.end_time}
                  </div>
                ) : null} */}
              </Col>
            </Row>
          </div>
          <div>
            <div className="f14-700 my-4">Lead Time</div>
            <div>
              <Row>
                <Col>
                  <FormControl component="fieldset">
                    <RadioGroup
                      row
                      name="leadTimeOption"
                      value={formik.values.leadTimeOption}
                      onChange={formik.handleChange}
                    >
                      <Row>
                        <Col xs={6} md={1}>
                          <FormControlLabel
                            value="hours"
                            control={<Radio />}
                            checked={formik.values.leadTimeOption === 'hours'}
                          />
                        </Col>
                        <Col xs={6} md={5}>
                          <Select
                            name="lead_time"
                            value={
                              formik.values.leadTimeOption === 'hours'
                                ? formik.values.lead_time
                                : ''
                            }
                            variant="outlined"
                            style={{ width: '100%' }}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            displayEmpty
                            disabled={formik.values.leadTimeOption !== 'hours'}
                            // error={
                            //   formik.touched.lead_time &&
                            //   Boolean(formik.errors.lead_time)
                            // }
                            fullWidth
                          >
                            <MenuItem value="" disabled>
                              Select Hours
                            </MenuItem>
                            {[...Array(24).keys()].map((i) => (
                              <MenuItem key={i + 1} value={i + 1}>
                                {i + 1} Hours
                              </MenuItem>
                            ))}
                          </Select>
                        </Col>
                        <Col xs={6} md={1}>
                          <FormControlLabel
                            value="days"
                            control={<Radio />}
                            checked={formik.values.leadTimeOption === 'days'}
                          />
                        </Col>
                        <Col xs={6} md={5}>
                          <Select
                            name="lead_time"
                            value={
                              formik.values.leadTimeOption === 'days'
                                ? formik.values.lead_time
                                : ''
                            }
                            style={{ width: '100%' }}
                            variant="outlined"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            displayEmpty
                            disabled={formik.values.leadTimeOption !== 'days'}
                            // error={
                            //   formik.touched.lead_time &&
                            //   Boolean(formik.errors.lead_time)
                            // }
                            fullWidth
                          >
                            <MenuItem value="" disabled>
                              Select Days
                            </MenuItem>
                            {[...Array(30).keys()].map((i) => (
                              <MenuItem key={i + 1} value={i + 1}>
                                {i + 1} Days
                              </MenuItem>
                            ))}
                          </Select>
                        </Col>
                      </Row>
                    </RadioGroup>
                    {/* {formik.errors.lead_time && formik.touched.lead_time && (
                      <div style={{ color: 'red', marginTop: '5px' }}>
                        {formik.errors.lead_time}
                      </div>
                    )} */}
                  </FormControl>
                </Col>
              </Row>
              <div className="f14-700 my-4">Cut Off Time</div>
              <Row>
                <Col>
                  <FormControl component="fieldset">
                    <RadioGroup
                      row
                      name="cutOffTimeOption"
                      value={formik.values.cutOffTimeOption}
                      onChange={formik.handleChange}
                    >
                      <Row>
                        <Col xs={6} md={1}>
                          <FormControlLabel
                            value="hours"
                            control={<Radio />}
                            checked={formik.values.cutOffTimeOption === 'hours'}
                          />
                        </Col>
                        <Col xs={6} md={5}>
                          <Select
                            name="cut_off_time"
                            value={
                              formik.values.cutOffTimeOption === 'hours'
                                ? formik.values.cut_off_time
                                : ''
                            }
                            variant="outlined"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            displayEmpty
                            disabled={
                              formik.values.cutOffTimeOption !== 'hours'
                            }
                            // error={
                            //   formik.touched.cut_off_time &&
                            //   Boolean(formik.errors.cut_off_time)
                            // }
                            fullWidth
                          >
                            <MenuItem value="" disabled>
                              Select Hours
                            </MenuItem>
                            {[...Array(24).keys()].map((i) => (
                              <MenuItem key={i + 1} value={i + 1}>
                                {i + 1} Hours
                              </MenuItem>
                            ))}
                          </Select>
                        </Col>
                        <Col xs={6} md={1}>
                          <FormControlLabel
                            value="minutes"
                            control={<Radio />}
                            checked={
                              formik.values.cutOffTimeOption === 'minutes'
                            }
                          />
                        </Col>
                        <Col xs={6} md={5}>
                          <Select
                            name="cut_off_time"
                            variant="outlined"
                            value={
                              formik.values.cutOffTimeOption === 'minutes'
                                ? formik.values.cut_off_time
                                : ''
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            displayEmpty
                            disabled={
                              formik.values.cutOffTimeOption !== 'minutes'
                            }
                            // error={
                            //   formik.touched.cut_off_time &&
                            //   Boolean(formik.errors.cut_off_time)
                            // }
                            fullWidth
                          >
                            <MenuItem value="" disabled>
                              Select Minutes
                            </MenuItem>
                            {[...Array(60).keys()].map((i) => (
                              <MenuItem key={i + 1} value={i + 1}>
                                {i + 1} Minutes
                              </MenuItem>
                            ))}
                          </Select>
                        </Col>
                      </Row>
                    </RadioGroup>
                    {/* {formik.errors.cut_off_time &&
                      formik.touched.cut_off_time && (
                        <div style={{ color: 'red', marginTop: '5px' }}>
                          {formik.errors.cut_off_time}
                        </div>
                      )} */}
                  </FormControl>
                </Col>
              </Row>{' '}
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default Availability;

export const RenderMultipleHoursInsideFields = ({
  state,
  errors,
  onDayOpenCloseHanlder,
  handleChangeOpeningCloseing,
  handleChangeInputTextArray,
  handleChangeMultipleHoursToggle,
  onFocusOut,
  deleteOnClick,
  addOnClick,
  copyMultipleTimeFunction,
  copyMultipleTimeFunctionError,
}) => {
  const dayDataMonData = state.monday.multiple_timings;
  let dayDataMonDataDesc =
    dayDataMonData[dayDataMonData?.length - 1] &&
    dayDataMonData[dayDataMonData?.length - 1].description;
  const dayDataTueData = state['tuesday'].multiple_timings;
  let dayDataTueDataDesc =
    dayDataTueData[dayDataTueData?.length - 1] &&
    dayDataTueData[dayDataTueData?.length - 1].description;
  const dayDataWedData = state['wednesday'].multiple_timings;
  let dayDataWedDataDesc =
    dayDataWedData[dayDataWedData?.length - 1] &&
    dayDataWedData[dayDataWedData?.length - 1].description;
  const dayDataThrData = state['thursday'].multiple_timings;
  let dayDataThrDataDesc =
    dayDataThrData[dayDataThrData?.length - 1] &&
    dayDataThrData[dayDataThrData?.length - 1].description;
  const dayDataFriData = state['friday'].multiple_timings;
  let dayDataFriDataDesc =
    dayDataFriData[dayDataFriData?.length - 1] &&
    dayDataFriData[dayDataFriData?.length - 1].description;
  const dayDataSatData = state['saturday'].multiple_timings;
  let dayDataSatDataDesc =
    dayDataSatData[dayDataSatData?.length - 1] &&
    dayDataSatData[dayDataSatData?.length - 1].description;
  const dayDataSunData = state['sunday'].multiple_timings;
  let dayDataSunDataDesc =
    dayDataSunData[dayDataSunData?.length - 1] &&
    dayDataSunData[dayDataSunData?.length - 1].description;

  return (
    <React.Fragment>
      <div className="margin-new-multiple-hours mb-5">
        {dayArray.map((day, index) => (
          <React.Fragment key={index}>
            <div className="standard-hours-main">
              <div className="standard-hours-main-sectionone">
                <Switch
                  checked={state[day].open}
                  onChange={onDayOpenCloseHanlder(day, foodTime, 'multiple')}
                  offColor="#EEEEEE"
                  onColor="#EEEEEE"
                  offHandleColor="#212121"
                  onHandleColor="#59F832"
                  handleDiameter={15}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  height={10}
                  width={28}
                  boxShadow="-2px 0px 5px #0000003B"
                  activeBoxShadow="-2px 0px 5px #0000003B"
                  id="material-switch"
                />
                <div className="f12-500 text-uppercase pl-2">{day}</div>
              </div>
              {state[day].open === true ? (
                <div className="">
                  {state[day].multiple_timings.map((hours, index) => (
                    <div
                      className="row mb-4 mt-3 pl-md-4 pl-lg-4 pl-xl-4 standard-hours-main-sectiontwo"
                      key={index}
                    >
                      <div className="col-9 col-md-5 col-lg-5 col-xl-5 pr-lg-0">
                        <div className="d-flex align-items-center justify-content-md-between">
                          <Switch
                            checked={hours.open}
                            onChange={handleChangeMultipleHoursToggle(
                              day,
                              hours,
                              index
                            )}
                            offColor="#EEEEEE"
                            onColor="#EEEEEE"
                            offHandleColor="#212121"
                            onHandleColor="#59F832"
                            handleDiameter={15}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={10}
                            width={28}
                            boxShadow="-2px 0px 5px #0000003B"
                            activeBoxShadow="-2px 0px 5px #0000003B"
                            id="material-switch"
                          />
                          <NewInputText
                            extraClass="mb-0 ml-3"
                            inputType="text"
                            onChange={handleChangeInputTextArray(day, index)}
                            onFocusOut={onFocusOut}
                            onKeyDown={InputCharacterCheck}
                            value={hours.description}
                            name="description"
                            errorText={
                              hours.description === '' ? errors.description : ''
                            }
                            errorTrue={
                              hours.description === '' &&
                              errors.description === 'Description Is Required'
                                ? true
                                : false
                            }
                            disabled={hours.open === true ? false : true}
                            labelText="Description"
                            controlClass={
                              hours.description === '' &&
                              errors.description === 'Description Is Required'
                                ? 'outlined-error-helper-text'
                                : 'outlined-helperText'
                            }
                          />
                        </div>
                      </div>
                      <div className="pt-m-10 pl-64 mobile-order-3 col-6 col-md-2 col-lg-3 col-xl-3 standard-hours-main-sectiontwo-insidetoggle ">
                        <TimeInput
                          mode="12h"
                          value={new Date(hours.opening_time)}
                          disabled={hours.open === true ? false : true}
                          onChange={(time) =>
                            handleChangeOpeningCloseing(
                              time,
                              day,
                              'opening_time',
                              index
                            )
                          }
                        />
                      </div>
                      <div className="pt-m-10 pl-64 mobile-order-3 col-6 col-md-2 col-lg-3 col-xl-3 standard-hours-main-sectiontwo-insidetoggle mobile-standard-hours-mainpending">
                        <TimeInput
                          mode="12h"
                          value={new Date(hours.closing_time)}
                          disabled={hours.open === true ? false : true}
                          onChange={(time) =>
                            handleChangeOpeningCloseing(
                              time,
                              day,
                              'closing_time',
                              index
                            )
                          }
                        />
                      </div>
                      <div className="col-2 col-sm-2 col-md-1 col-lg-1 col-xl-1 p-0 d-flex align-items-center justify-content-between">
                        {state[day].multiple_timings?.length > 1 ? (
                          <div>
                            <AddButtonIconComponent
                              buttonText="Delete"
                              onClick={deleteOnClick(day, index)}
                              fontIcon="fa fa-trash-o"
                              colorCss="delete"
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>
                  ))}
                  <div className="col-12 d-flex p-0 restaurant_details_onboarding_minus_button">
                    <div className="col-6">
                      <AddButtonIconComponent
                        buttonText="Add Another Slot"
                        onClick={addOnClick(day)}
                        fontIcon="fa fa-plus"
                        colorCss="blue"
                      />
                    </div>
                    <div className="col-6 d-flex justify-content-end">
                      <AddButtonIconComponent
                        buttonText="Copy Timing to Rest of the Days"
                        onClick={
                          (dayDataMonDataDesc === '' &&
                            dayDataTueDataDesc === '' &&
                            dayDataWedDataDesc === '' &&
                            dayDataThrDataDesc === '' &&
                            dayDataFriDataDesc === '' &&
                            dayDataSatDataDesc === '' &&
                            dayDataSunDataDesc === '') ||
                          state.checkPoint === true
                            ? copyMultipleTimeFunctionError
                            : copyMultipleTimeFunction(day)
                        }
                        fontIcon="fa fa-clone"
                        colorCss="red"
                        displayIcon="clone"
                        //
                      />
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
          </React.Fragment>
        ))}
      </div>
    </React.Fragment>
  );
};
